import { STATS } from '@/mocks/anime';

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      {/* 背景图 + 暗色遮罩 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dreamy%20stylized%20anime%20illustration%20of%20a%20vibrant%20cityscape%20at%20dusk%20with%20floating%20cherry%20blossoms%2C%20neon%20lights%20and%20warm%20clouds%2C%20energetic%20yet%20calm%20atmosphere%2C%20warm%20coral%20and%20teal%20color%20palette%2C%20soft%20artistic%20digital%20painting%20style&width=1600&height=1000&seq=hero-bg-01&orientation=landscape"
          alt="卡通动漫第一页 动漫城市插画背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-background-50"></div>
      </div>

      {/* 浮动装饰气泡 */}
      <div className="anim-blob pointer-events-none absolute left-[8%] top-[22%] h-24 w-24 rounded-full bg-secondary-400/30 blur-2xl"></div>
      <div className="anim-blob pointer-events-none absolute right-[10%] top-[30%] h-32 w-32 rounded-full bg-primary-400/30 blur-2xl" style={{ animationDelay: '-6s' }}></div>
      <div className="anim-blob pointer-events-none absolute bottom-[18%] left-[38%] h-20 w-20 rounded-full bg-accent-400/30 blur-2xl" style={{ animationDelay: '-10s' }}></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 pb-16 pt-28 md:px-6 md:pb-24 md:pt-40">
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center text-center">
          <span className="anim-fade-up inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-black/25 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
            <i className="ri-verified-badge-fill text-secondary-300"></i>
            动漫爱好者的一站式追更入口
          </span>

          <h1 className="anim-fade-up mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl md:leading-tight" style={{ animationDelay: '0.1s' }}>
            卡通动漫第一页
            <span className="mt-2 block text-2xl text-secondary-300 md:text-4xl">入口直达 · 官网首页一键进入</span>
          </h1>

          <p className="anim-fade-up mt-6 max-w-xl text-sm leading-7 text-background-100/90 md:text-base" style={{ animationDelay: '0.2s' }}>
            想看漫画、追新番不迷路？直接进卡通动漫第一页在线页面。热门作品、新番连载、主题分类一网打尽，入口清晰、打开即看，收藏本站随时追更。
          </p>

          <div className="anim-fade-up mt-9 flex flex-col gap-3 sm:flex-row" style={{ animationDelay: '0.3s' }}>
            <a href="#hot" className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap">
              <i className="ri-play-circle-fill text-lg"></i>
              立即开看热门作品
            </a>
            <a href="#new" className="inline-flex items-center justify-center gap-2 rounded-full border border-background-50/40 bg-black/20 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-black/30 whitespace-nowrap">
              <i className="ri-calendar-check-fill text-lg"></i>
              查看新番连载
            </a>
          </div>

          {/* 快捷分类标签 */}
          <div className="anim-fade-up mt-8 flex flex-wrap items-center justify-center gap-2" style={{ animationDelay: '0.4s' }}>
            {['热血冒险', '奇幻异界', '恋爱日常', '治愈系', '悬疑推理'].map((c) => (
              <a key={c} href="#category" className="rounded-full bg-black/20 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur transition-colors hover:bg-black/35 whitespace-nowrap">
                {c}
              </a>
            ))}
          </div>
        </div>

        {/* 数据条 */}
        <div className="anim-fade-up mt-12 grid grid-cols-2 gap-3 sm:grid-cols-4 md:mt-16" style={{ animationDelay: '0.5s' }}>
          {STATS.map((s) => (
            <div key={s.label} className="rounded-2xl border border-background-50/15 bg-black/25 px-4 py-5 text-center backdrop-blur">
              <p className="font-heading text-2xl text-secondary-300 md:text-3xl">{s.num}</p>
              <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* 底部波浪过渡 */}
      <svg className="relative z-10 block w-full text-background-50" viewBox="0 0 1440 60" fill="none" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 60L60 50C120 40 240 20 360 15C480 10 600 20 720 28C840 36 960 42 1080 40C1200 38 1320 28 1380 23L1440 18V60H0Z" fill="currentColor" />
      </svg>
    </section>
  );
}